module.exports = __webpack_public_path__ + "static/media/temp_24.de2fadae.jpg";